import React, { createContext, useState, useEffect, useReducer } from 'react'
import getAxios from '../axios/Axios'
import {request} from '../request/request'
import { useDispatch } from 'react-redux'

const UserContext = createContext({
    userData: [],
    whoamiFunc: () => {},
    login: false,
    tagFilter: [],
    setTagFilter: () => {}
})

function userReducer(state, action) {
    // switch (action.type) {
    //     case 'login':
    //         // return { ...state, login: action.login }
    //     default:
    //         // return state
    // }
}

function UserProvider({ children }) {
    const [data, setData] = useState([])
    const [userLogin, setUserLogin] = useState(false)
    // const [tagFilter, setTagFilter] = useState([])
    // const [ dispatch] = useReducer(userReducer, { login: false })
    const dispatch = useDispatch()

    useEffect(() => {
        whoamiFunction()
    }, [])

    // const clearFilter = (clean, isClear) => {
    //     if (isClear)
    //         clean()
    // }

    const whoamiFunction = async () => {
        console.log("whoami called...")
        try {
            const res = await getAxios(request.whoami)
            if (res?.data?.apiresponse?.code==='LOGGEDIN') {
                setData(res?.data)
                dispatch({ type: "login", login: true })
            } else {
                dispatch({ type: "login", login: false })
            }
        } catch {
            setUserLogin(false)
        }
    }

    const UserContextValue = {
        userData: data,
        whoamiFunc: whoamiFunction,
        login: userLogin,

    }

    return (
        <UserContext.Provider value={UserContextValue}>
            {children}
        </UserContext.Provider>
    )
}

export default UserProvider
export { UserContext }
